/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { PharmacyAddress } from "./PharmacyAddress";
import type { PharmacyPosition } from "./PharmacyPosition";

export interface PharmacyLocation {
  /** Dosespot pharmacy identifier */
  id: string;
  /** Pharmacy name */
  name?: string;
  /** Pharmacy address */
  address?: PharmacyAddress;
  /** Geographic position */
  position?: PharmacyPosition | null;
  /** Primary phone number */
  phone?: string;
  /** Whether the pharmacy is sponsored */
  is_sponsored?: boolean;
}
